import request from '@/utils/request'

/**
 * 商家-客服绑定
 */

// 可选客服列表(C端客服用户)
export function kfOptions() {
  return request({
    url: '/user/merchant/kf/kfOptions',
    method: 'get'
  })
}

// 商家分页查询(含绑定客服信息)
export function merchantKfPage(query) {
  return request({
    url: '/user/merchant/kf/merchantPage',
    method: 'get',
    params: query
  })
}

// 绑定/换绑客服(一个商家一个客服)
export function bindMerchantKf(data) {
  return request({
    url: '/user/merchant/kf/bind',
    method: 'post',
    data
  })
}

// 解绑客服
export function unbindMerchantKf(data) {
  return request({
    url: '/user/merchant/kf/unbind',
    method: 'post',
    data
  })
}
